import * as z from "zod/v4";

export const ecwidIntegrationSchema = z.object({
  enabled: z.boolean(),
  storeId: z.string(),
  accessTokenPreview: z.string(),
  customerGroup: z.string(),
  createForReturns: z.boolean(),
  createForClaims: z.boolean(),
  createForWarranties: z.boolean(),
  filterByReturnReason: z.boolean(),
  allowedReturnReasons: z.array(z.string()),
});

export type EcwidIntegration = z.infer<typeof ecwidIntegrationSchema>;

export const getEcwidIntegration = {
  name: "getEcwidIntegration" as const,
  input: z.object({}),
  output: z.object({ integration: ecwidIntegrationSchema.nullable() }),
};
